import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bsc-finance',
  templateUrl: './bsc-finance.component.html',
  styleUrls: ['./bsc-finance.component.scss']
})
export class BscFinanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
